
export const environment = {
  duuUploadBucket : 'bridge-preprod2-bucket-duu-zip-upload',
  identityPoolId:  'us-east-2:1652407f-0424-4ec1-a31d-d62c2f693cab',
  s3_endpoint: '',
  sts_endpoint: '',
  s3_downUrl: 'https://s3.amazonaws.com',
  appVersion: 'Version 1.0.0',
  baseUrl: 'https://api.preprod2.bridge.lumino.smith-nephew.com',
  baseUrlClp: 'https://api.preprod2.bridge.lumino.smith-nephew.com',
  baseUrlClpSnn: 'https://api-snn.preprod2.bridge.lumino.smith-nephew.com',
  baseUnauthUrl: 'https://api2.preprod2.bridge.lumino.smith-nephew.com',
  userPoolAwsLogin:  'cognito-idp.us-east-2.amazonaws.com/us-east-2_4c5XAjM0i',
  production: true,
  lensSenderEmail: 'snnoreply@maildrop.cc',
  destinationBucket: 'cup-dev-lumino',
  region: 'us-east-2',
  apiVersionCognito: '2016-04-18',
  apiVersionSqs: '2012-11-05',
  inactivityIdleTime: 900,
  lambdaFunction: {
    bridgeDuuProcessZipUpload: 'bridge-preprod2-duu-process-zip-upload',
    lambdaRegion: 'us-east-2'
  },
  ssmParams : {
    IDLETIME : "/bridge-preprod2/image-upload-service_preprod2/inactivityTime_login",
    DIACOMTAG : "/bridge-preprod2/image-upload-service_preprod2/validDicomTags",
    RECALLTIME : "/bridge-preprod2/image-upload-service_preprod2/recallTime",
    AUDITINTERVALTIME : "/bridge-preprod2/image-upload-service_preprod2/auditInterval",
	APPDIACOMTAGSCRIPT : "/bridge-preprod2/image-upload-service_preprod2/validApplicationDicomTags",
    APPVERSION: "/bridge-preprod2/image-upload-service_preprod2/appVersionInfo",
    SQSQUEUEURL: "/bridge-preprod2/DUU_Group_by_patient/group-by-patient-queue-url",
  },
  //ALL ROLES EXPECT SNN
  clp: {
    hostedUIUrl: "https://bridge-preprod2-clp-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-preprod2-clp-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:1652407f-0424-4ec1-a31d-d62c2f693cab",
    userPoolId: "us-east-2_4c5XAjM0i",
    userPoolWebClientId: "5mrtri0o6hdn5gaqcote69760j",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_4c5XAjM0i",
    cloudfrontCLPURL: 'https://clp.preprod2.bridge.lumino.smith-nephew.com',
    cloudFrontCLPSignInUrl: 'https://clp.preprod2.bridge.lumino.smith-nephew.com/signin',
    cloudFrontCLPSignOutUrl: 'https://clp.preprod2.bridge.lumino.smith-nephew.com/logout',
    cloudFrontCLPExitAppUrl: 'https://clp.preprod2.bridge.lumino.smith-nephew.com/application/product',
  },
  //SNN ROLE
  snnClp: {
    hostedUIUrl: "https://bridge-preprod2-snn-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-preprod2-snn-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:8f365513-ef76-488d-a739-5962b21efd85",
    userPoolId: "us-east-2_Erbi28GQ1",
    userPoolWebClientId: "1jj76581hcbrpd24vbgerc54o6",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_Erbi28GQ1",
    cloudfrontCLPURL: 'https://snn.preprod2.bridge.lumino.smith-nephew.com',
    cloudFrontCLPSignInUrl: 'https://snn.preprod2.bridge.lumino.smith-nephew.com/signin',
    cloudFrontCLPSignOutUrl: 'https://snn.preprod2.bridge.lumino.smith-nephew.com/logout',
    cloudFrontCLPExitAppUrl: 'https://snn.preprod2.bridge.lumino.smith-nephew.com/application/product',
  },
  duuCloudFrontSigninUrl: 'https://duu.preprod2.bridge.lumino.smith-nephew.com/signin',
};
